import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

import {ImageThumb} from './imagethumb.component'

export class BookingItemBlock extends React.Component {
    constructor(props) {
        super(props)
    }	

    render() {
        let conf = this.props.item.getIn(['reservation_details', 'confirmation_code']) ? <div><span>Confirmation Code: </span>{this.props.item.getIn(['reservation_details', 'confirmation_code'])}</div> : null
        let notes = this.props.item.getIn(['reservation_details', 'notes']) ? <div><span>Notes: </span>{this.props.item.getIn(['reservation_details', 'notes'])}</div> : null
    
        return (
            <div className="booking-list-item">
                <div className="booking-list-item-header">
                    <h3>
                        <ImageThumb item={ this.props.item } showDetails={() => { this.props.showDetails(this.props.item) } } useIcon={ true }/> 
                        {this.props.item.get('name')}
                    </h3>
                </div>
                <div className="booking-list-item-details">
                    {conf}
                    {notes}
                </div>
                <div className="booking-list-item-tools hidden">
                    <i className="icon-filters"/>
                    <i className="icon-reservation"/>
                    <i className="icon-chat"/>
                    <i className="icon-diamond"/>
                </div>
                <div className="booking-list-item-status hidden">
                    <i className="icon-complete"/>
                </div>              
            </div>   
        )
    }
}
